document.addEventListener('DOMContentLoaded', function() {
  let swiper = null;
  let resizeTimer = /** @type {ReturnType<typeof setTimeout> | undefined} */ (undefined);
  
  // Initialize swiper
  function initSwiper() {
    const productSlider = document.querySelector('.collection-tabs');
    
    if (productSlider) {
      // Destroy existing instance if any
      if (swiper) {
        swiper.destroy(true, true);
      }
      
      swiper = new Swiper('.collection-tabs', {
        slidesPerView: 3.5,
        spaceBetween: 14,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.collection-tabs-nav-btn-next-mob',
          prevEl: '.collection-tabs-nav-btn-prev-mob',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        on: {
          init: function() {
            equalizeSlideHeights(this);
          },
          resize: function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => equalizeSlideHeights(this), 150);
          },
          slideChange: function() {
            equalizeSlideHeights(this);
          }
        },
        breakpoints: {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 10,
          },
          520: {
            slidesPerView: 1.5,
            spaceBetween: 12,
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          960: {
            slidesPerView: 2.5,
            spaceBetween: 12,
            navigation: {
              nextEl: '.collection-tabs-nav-btn-next',
              prevEl: '.collection-tabs-nav-btn-prev',
            }
          },
          1070: {
            slidesPerView: 3,
            spaceBetween: 14,
            navigation: {
              nextEl: '.collection-tabs-nav-btn-next',
              prevEl: '.collection-tabs-nav-btn-prev',
            }
          },
          1280: {
            slidesPerView: 3.5,
            spaceBetween: 14,
            navigation: {
              nextEl: '.collection-tabs-nav-btn-next',
              prevEl: '.collection-tabs-nav-btn-prev',
            }
          },
        },
      });
    }
  }
  
  // Initialize on page load
  initSwiper();
  
  // Handle tab clicks
  const tabs = document.querySelectorAll('.collection-tab');
  const sliderWrapper = document.querySelector('.collection-tabs-wrapper');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', async function() {
      const collectionHandle = this.getAttribute('data-collection-handle');
      
      // Update active state
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      // Add loading state
      if (sliderWrapper) {
        sliderWrapper.style.opacity = '0.5';
        sliderWrapper.style.pointerEvents = 'none';
        sliderWrapper.style.transition = 'opacity 0.3s ease';
      }
      
      // Fetch new content
      try {
        const response = await fetch(`/collections/${collectionHandle}?section_id=collection-tabs-slider`);
        const html = await response.text();
        
        // Update the slider wrapper content
        if (sliderWrapper) {
          sliderWrapper.innerHTML = html;
          
          // Reinitialize swiper
          initSwiper();
          
          // Remove loading state
          sliderWrapper.style.opacity = '1';
          sliderWrapper.style.pointerEvents = 'auto';
        }
      } catch (error) {
        console.error('Error loading collection:', error);
        
        // Remove loading state on error
        if (sliderWrapper) {
          sliderWrapper.style.opacity = '1';
          sliderWrapper.style.pointerEvents = 'auto';
        }
      }
    });
  });
  
  // Function to equalize slide heights
  function equalizeSlideHeights(/** @type {any} */ swiperInstance) {
    const slides = swiperInstance.slides;
    if (!slides || slides.length === 0) return;

    // Reset heights (write)
    slides.forEach(slide => {
      slide.style.height = 'auto';
    });

    // Batch: read all heights, then write — avoids layout thrashing
    requestAnimationFrame(() => {
      const heights = Array.from(slides).map(slide => slide.offsetHeight);
      const maxHeight = Math.max(...heights);

      if (maxHeight > 0) {
        slides.forEach(slide => {
          slide.style.height = maxHeight + 'px';
        });
      }
    });
  }
});